
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.336 12.547l-7.599 6.846L24.859 29.4 16 24.289 7.141 29.4l2.122-10.006-7.599-6.847 10.172-1.073L16 2.131l4.164 9.343z"}})])
          )
        }
      }
    